import React from 'react';

const IconMapMarker = ({ className = null }) => {
  return (
    <svg
      className={className}
      height="32px"
      viewBox="0 0 128 128"
      width="32px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m63.63,0C33.77,0,9.77,24,10.3,53.87c0,13.33,10.13,34.13,30.4,62.4,5.33,7.47,13.87,11.73,22.93,11.73s17.6-4.27,23.47-11.73c20.27-27.73,30.4-49.07,30.4-62.4C117.5,24,93.5,0,63.63,0Z"
        fill="currentColor"
      />
      <path
        d="m63.85,35.65c-10.45,0-19,8.55-19,19s8.55,19,19,19,19-8.55,19-19-8.55-19-19-19Zm0,28.5c-5.23,0-9.5-4.27-9.5-9.5s4.27-9.5,9.5-9.5,9.5,4.27,9.5,9.5-4.27,9.5-9.5,9.5Z"
        fill="#fff"
      />
      <path
        d="m63.66,120.71c-8.03,0-15.6-3.78-20.32-10.4-17.96-25.05-26.94-43.48-26.94-55.29-.47-26.47,20.79-47.73,47.26-47.73s47.73,21.27,47.73,47.73c0,11.81-8.98,30.72-26.94,55.29-5.2,6.62-12.76,10.4-20.79,10.4Zm0-103.03c-20.32,0-37.34,16.54-37.34,37.34,0,9.45,8.98,26.94,25.05,49.62,4.73,6.62,14.18,8.03,20.79,3.31,1.42-.95,2.36-1.89,3.31-3.31,16.07-22.21,25.05-40.17,25.05-49.62.47-20.79-16.54-37.34-36.86-37.34Z"
        fill="#fff"
      />
      <path
        d="m63.7,113.27c-6.83,0-13.26-3.21-17.27-8.84-15.26-21.29-22.9-36.96-22.9-47-.4-22.5,17.68-40.57,40.17-40.57s40.57,18.08,40.57,40.57c0,10.04-7.63,26.11-22.9,47-4.42,5.62-10.85,8.84-17.68,8.84Zm0-87.57c-17.27,0-31.73,14.06-31.73,31.73,0,8.03,7.63,22.9,21.29,42.18,4.02,5.62,12.05,6.83,17.68,2.81,1.21-.8,2.01-1.61,2.81-2.81,13.66-18.88,21.29-34.15,21.29-42.18.4-17.68-14.06-31.73-31.33-31.73Z"
        fill="currentColor"
      />
      <path
        d="m63.85,42.3c-6.79,0-12.35,5.56-12.35,12.35s5.56,12.35,12.35,12.35,12.35-5.56,12.35-12.35-5.56-12.35-12.35-12.35Zm0,18.52c-3.4,0-6.18-2.78-6.18-6.18s2.78-6.18,6.18-6.18,6.18,2.78,6.18,6.18-2.78,6.18-6.18,6.18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconMapMarker;
